<template>
  <header
    id="header"
    class="fixed-top d-flex align-items-center"
  >
    <div class="container pr-2 pl-2 d-flex align-items-center justify-content-between">

      <div class="logo">
        <a
          href="/home"
          class="logo-wrap"
        ><img
          src="/minds-academy-lockup.png"
          alt="Minds' Academy"
          class="img-fluid"
        ></a>
      </div>

      <nav
        id="navbar"
        :class="['navbar', { 'navbar-mobile': isMobileNavOpen }]"
      >
        <ul>
          <li><a
            class="nav-link scrollto active"
            href="/home"
            @click="isMobileNavOpen = false"
          >{{ $t('nav.home') }}</a></li>
          <li><a
            class="nav-link scrollto"
            href="/home#demos"
            @click.prevent="scrollToSection('demos')"
          >{{ $t('nav.solutions') }}</a></li>
          <li><a
            class="nav-link scrollto"
            href="/home#faq"
            @click.prevent="scrollToSection('faq')"
          >{{ $t('nav.faq') }}</a></li>
          <li><a
            class="nav-link scrollto"
            href="/contact"
            @click.prevent="isMobileNavOpen = false; $router.push('/contact')"
          >{{ $t('nav.contact') }}</a></li>
          <li
            v-if="registrationEnabled"
            class="dropdown"
          ><a class="getstarted getstarted-outline scrollto">{{ $t('nav.login') }}</a>
            <ul>
              <li><a
                href="/login/student"
                @click="isMobileNavOpen = false"
              >{{ $t('nav.student') }}</a></li>
              <li><a
                href="/login/tutor"
                @click="isMobileNavOpen = false"
              >{{ $t('nav.tutor') }}</a></li>
            </ul>
          </li>
          <li v-if="registrationEnabled">
            <a
              class="getstarted scrollto"
              href="/inscription"
              @click="isMobileNavOpen = false"
            >{{ $t('nav.signup') }}</a>
          </li>
        </ul>
        <div class="nav-actions">
          <button
            type="button"
            class="lang-switcher"
            :aria-label="currentLang === 'fr' ? 'Switch to English' : 'Passer en français'"
            @click="toggleLang"
          >
            <img
              :src="currentLangFlag"
              class="lang-flag"
              :alt="currentLang"
            >
            <span class="lang-code">{{ currentLang.toUpperCase() }}</span>
          </button>
          <button
            type="button"
            class="mobile-nav-toggle"
            :aria-label="isMobileNavOpen ? (currentLang === 'fr' ? 'Fermer le menu' : 'Close menu') : (currentLang === 'fr' ? 'Ouvrir le menu' : 'Open menu')"
            @click="toggleMobileNav"
          >
            <span aria-hidden="true">{{ isMobileNavOpen ? '×' : '☰' }}</span>
          </button>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
const flagFr = require('@/assets/images/flags/fr.png')
const flagEn = require('@/assets/images/flags/en.png')

export default {
  name: 'NavBar',
  data() {
    return {
      isMobileNavOpen: false,
    }
  },
  computed: {
    registrationEnabled() {
      return process.env.VUE_APP_REGISTRATION_ENABLED === 'true'
    },
    currentLang() {
      return this.$i18n.locale
    },
    currentLangFlag() {
      return this.$i18n.locale === 'fr' ? flagFr : flagEn
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    toggleMobileNav() {
      this.isMobileNavOpen = !this.isMobileNavOpen
    },
    toggleLang() {
      const next = this.$i18n.locale === 'fr' ? 'en' : 'fr'
      this.$i18n.locale = next
      localStorage.setItem('tuttop_lang', next)
    },
    handleScroll() {
      const header = document.getElementById('header')
      if (!header) return
      if (window.scrollY > 60) {
        header.classList.add('header-scrolled')
      } else {
        header.classList.remove('header-scrolled')
      }
    },
    scrollToSection(id) {
      this.isMobileNavOpen = false
      const el = document.getElementById(id)
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - 90
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' })
      } else {
        this.$router.push({ path: '/home', hash: `#${id}` })
      }
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 768px) {
  [data-aos-delay] {
    transition-delay: 0 !important;
  }
}

#header {
  z-index: 997;
  transition: all 0.5s;
  padding: 14px 20px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(20, 184, 166, 0.10);
  box-shadow: 0 1px 20px rgba(20, 184, 166, 0.07);
}

#header.header-scrolled {
  background: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(20, 184, 166, 0.12);
  box-shadow: 0 2px 25px rgba(20, 184, 166, 0.10);
  padding: 12px 20px;
}

#header .logo .logo-wrap {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  border: 1px solid rgba(20, 184, 166, 0.12);
}
#header .logo img {
  padding: 0;
  margin: 0;
  max-height: 69px;
}

.navbar {
  padding: 0;
  display: flex;
  align-items: center;
}

.navbar ul {
  margin: 0;
  padding: 0;
  display: flex;
  list-style: none;
  align-items: center;
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 14px;
}

.navbar li {
  position: relative;
}

.navbar a,
.navbar a:focus {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 10px 30px;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a2e;
  white-space: nowrap;
  transition: 0.3s;
  text-decoration: none;
}

.navbar a i,
.navbar a:focus i {
  font-size: 22px;
  line-height: 0;
  margin-left: 5px;
}

.navbar a:hover,
.navbar .active,
.navbar .active:focus,
.navbar li:hover > a {
  color: var(--brand-blue);
}

.navbar .getstarted,
.navbar .getstarted:focus {
  background: linear-gradient(135deg, var(--brand-blue), var(--brand-blue-deep));
  padding: 9px 26px;
  margin-left: 20px;
  border-radius: 50px;
  color: #fff;
  font-weight: 600;
  border: none;
  transition: all 0.35s ease;
  box-shadow: 0 3px 15px rgba(20, 184, 166, 0.22);
}

.navbar .getstarted:hover,
.navbar .getstarted:focus:hover {
  color: #fff;
  background: linear-gradient(135deg, var(--brand-blue-deep), var(--brand-blue));
  box-shadow: 0 5px 25px rgba(20, 184, 166, 0.35);
  transform: translateY(-1px);
}

.navbar .getstarted-outline,
.navbar .getstarted-outline:focus {
  background: transparent;
  border: 1.5px solid rgba(20, 184, 166, 0.30);
  color: var(--brand-blue);
  box-shadow: none;
}

.navbar .getstarted-outline:hover,
.navbar .getstarted-outline:focus:hover {
  background: rgba(20, 184, 166, 0.08);
  border-color: rgba(20, 184, 166, 0.40);
  color: var(--brand-blue);
  box-shadow: none;
}

.navbar .dropdown ul {
  display: block;
  position: absolute;
  left: 30px;
  top: calc(100% + 30px);
  margin: 0;
  padding: 8px 0;
  z-index: 99;
  opacity: 0;
  visibility: hidden;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 10px 40px rgba(20, 184, 166, 0.10), 0 2px 10px rgba(0,0,0,0.04);
  border: 1px solid rgba(20, 184, 166, 0.10);
  transition: 0.3s;
  border-radius: 12px;
}

.navbar .dropdown ul li {
  min-width: 160px;
}

.navbar .dropdown ul a {
  padding: 10px 20px;
  font-size: 14px;
  color: #1a1a2e;
}

.navbar .dropdown ul a:hover,
.navbar .dropdown ul .active:hover,
.navbar .dropdown ul li:hover > a {
  color: var(--brand-blue);
  background: rgba(20, 184, 166, 0.06);
}

.navbar .dropdown:hover > ul {
  opacity: 1;
  top: 100%;
  visibility: visible;
}

.navbar .dropdown .dropdown ul {
  top: 0;
  left: calc(100% - 30px);
  visibility: hidden;
}

.navbar .dropdown .dropdown:hover > ul {
  opacity: 1;
  top: 0;
  left: 100%;
  visibility: visible;
}

@media (max-width: 1366px) {
  .navbar .dropdown .dropdown ul {
    left: -90%;
  }
  .navbar .dropdown .dropdown:hover > ul {
    left: -100%;
  }
}

.mobile-nav-toggle {
  color: #1a1a2e;
  font-size: 28px;
  cursor: pointer;
  display: none;
  line-height: 1;
  transition: 0.5s;
  background: transparent;
  border: none;
  padding: 6px 10px;
}

@media (max-width: 991px) {
  .mobile-nav-toggle {
    display: block;
  }
  .navbar ul {
    display: none;
  }
  #header {
    padding: 8px 12px;
  }
  #header.header-scrolled {
    padding: 6px 12px;
  }
  #header .logo .logo-wrap {
    padding: 4px 8px;
    border-radius: 8px;
  }
  #header .logo img {
    max-height: 40px;
  }
}

.navbar-mobile {
  position: fixed;
  overflow: hidden;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.97);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  transition: 0.3s;
  z-index: 999;
}

.navbar-mobile .nav-actions {
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  margin-left: 0;
  justify-content: space-between;
}

.navbar-mobile ul {
  display: block;
  position: absolute;
  top: 55px;
  right: 15px;
  bottom: 15px;
  left: 15px;
  padding: 10px 0;
  border-radius: 12px;
  background: #fff;
  border: 1px solid rgba(20, 184, 166, 0.10);
  box-shadow: 0 5px 30px rgba(0,0,0,0.06);
  overflow-y: auto;
  transition: 0.3s;
}

.navbar-mobile a,
.navbar-mobile a:focus {
  padding: 10px 20px;
  font-size: 15px;
  color: #1a1a2e;
}

.navbar-mobile a:hover,
.navbar-mobile .active,
.navbar-mobile li:hover > a {
  color: var(--brand-blue);
}

.navbar-mobile .getstarted,
.navbar-mobile .getstarted:focus {
  margin: 8px 20px 0;
  display: block;
  text-align: center;
  border-radius: 10px;
}

.navbar-mobile .getstarted-outline,
.navbar-mobile .getstarted-outline:focus {
  margin: 4px 20px 8px;
}

.navbar-mobile .dropdown ul {
  position: static;
  display: block;
  margin: 0 0 4px 0;
  padding: 0;
  z-index: 99;
  opacity: 1;
  visibility: visible;
  background: #f0f7ff;
  border: none;
  box-shadow: none;
  border-radius: 0 0 10px 10px;
}

.navbar-mobile .dropdown ul li {
  min-width: 200px;
}

.navbar-mobile .dropdown ul a {
  padding: 10px 20px;
}

.navbar-mobile .dropdown ul a:hover,
.navbar-mobile .dropdown ul .active:hover,
.navbar-mobile .dropdown ul li:hover > a {
  color: var(--brand-blue);
}

.navbar-mobile .dropdown > .dropdown-active {
  display: block;
}

.lang-switcher {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  margin-left: 0;
  border-radius: 8px;
  transition: background 0.2s;
  border: none;
  background: transparent;
}
.lang-switcher:hover {
  background: rgba(20, 184, 166, 0.08);
}
.lang-flag {
  width: 24px;
  height: 16px;
  border-radius: 2px;
  object-fit: cover;
}

.lang-code {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.06em;
  color: #1a1a2e;
  margin-left: 8px;
}
</style>
